import { useState } from 'react';
import { useStore } from 'hooks/useRootStore';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useMutation, useQuery } from 'react-query';
import { Box } from '@material-ui/core';
import { useStyles } from './styles';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { handleCompanyUrl } from 'utils/organizationUtils';
import { useHistory } from 'react-router-dom';
import { Card, CardContent, Typography, Grid } from '@material-ui/core';
import GoogleSvg from '../../../assets/googlelogo.svg';
import ZoomSvg from '../../../assets/zoom-logo.png';
import MicrosoftSvg from '../../../assets/microsoft.png';
import GithubSvg from '../../../assets/GitHub-logo.png';
export const AppTable: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const {
    ldapStore: { updateApp, getGroups },
    groupTableStore: { getAppGroup },
    AppStore: { providerList },
    notificationStore: { openNotification },
  } = useStore();
  const [currentGroup] = useState<any>(JSON.parse(localStorage.getItem('CurrentGroup') as string));
  const providerListReq = useQuery('providerListReq', () => providerList(), {
    onError: () => openNotification('error', `We are unable to connect `),
  });

  const entityId = currentGroup?.group_id || currentGroup?.id;
  const backRoute = '/group/users?value=three';
  const updateAppReq = useMutation((data: { providers: string[] }) => updateApp('group', entityId, data), {
    mutationKey: 'updateAppReq',
    onSuccess: async () => {
      await getGroups();
      openNotification('success', 'Saved!!');
      localStorage.setItem('activeTab', 'two');
      history.push(handleCompanyUrl(backRoute));
    },
    onError: (error: any) => openNotification('error', error?.message || `Can't update apps`),
  });

  const getAppGroupReq = useQuery('getAppGroup', () => getAppGroup(currentGroup?.group_id), {
    onError: (error: Error) => {
      openNotification('error', error.message);
    },
  });

  const filteredProviders =
    providerListReq?.data?.filter((app: any) => {
      const isActive = app.tokenStatus !== 'expired';
      const isAlreadyAdded = getAppGroupReq?.data?.includes(app.provider);
      return isActive && !isAlreadyAdded;
    }) || [];
  const handleReSync = (provider: string) => {
    updateAppReq.mutate({
      providers: [provider],
    });
  };
  const getAppLogo = (appName: string) => {
    switch (appName.toLowerCase()) {
      case 'google':
        return GoogleSvg;
      case 'zoom':
        return ZoomSvg;
      case 'microsoft':
        return MicrosoftSvg;
      case 'github':
        return GithubSvg;
      default:
        return GoogleSvg;
    }
  };

  const getCardClass = (appName: string) => {
    return `${classes.card} ${classes.approvedCard}`;
  };

  useAppPreloader(providerListReq.isFetching || updateAppReq.isLoading || getAppGroupReq.isLoading);
  return (
    <div>
      <div className={classes.page}>
        {!getAppGroupReq.isFetching &&
          (filteredProviders.length === 0 ? (
            <h1 className={classes.link}>No apps connected to this group.</h1>
          ) : (
            <Grid container spacing={3}>
              {filteredProviders.map((app: any) => (
                <Grid item xs={12} sm={6} md={4} key={app.id}>
                  <Card className={getCardClass(app.provider)}>
                    <CardContent>
                      <AddCircleOutlineIcon
                        className={classes.topIcon}
                        style={{
                          color: '#4CAF50',
                          fontSize: 28,
                          cursor: 'pointer',
                        }}
                        onClick={() => handleReSync(app.provider)}
                      />

                      <div className={classes.appRow}>
                        <img src={getAppLogo(app.provider)} alt={app.provider} className={classes.appIcon} />

                        <Box>
                          <Typography className={classes.appName}>
                            {app.provider === 'microsoft' ? 'Microsoft Entra / Office 365 Workspace' : app.provider}
                          </Typography>

                          <Typography className={classes.appDesc}>Access granted</Typography>
                        </Box>
                      </div>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          ))}
        {/* {getAppGroupReq.isFetching === false && (
                { filteredProviders && filteredProviders.length === 0 ? (
                    <h1 className={classes.link}>No apps connected to this group.</h1>
                ) : (
                    <Grid container spacing={3}>
                        {filteredProviders.map((app: any, index: number) => (
                            <Grid item xs={12} sm={6} md={4} key={app.id}>
                                <Card className={getCardClass(app.provider)}>
                                    <CardContent>
                                        <AddCircleOutlineIcon
                                            className={classes.topIcon}
                                            style={{
                                                color: '#4CAF50',
                                                fontSize: 28,
                                                cursor: 'pointer',
                                            }}
                                            onClick={() => handleReSync(app.provider)}
                                        />
                                        <div className={classes.appRow}>
                                            <img
                                                src={getAppLogo(app.provider)}
                                                alt={app.provider}
                                                className={classes.appIcon}
                                            />

                                            <Box>
                                                <Typography className={classes.appName}>
                                                    {app.provider}
                                                </Typography>

                                                <Typography className={classes.appDesc}>
                                                    Access granted
                                                </Typography>
                                            </Box>
                                        </div>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>

                )}
                )} */}
      </div>
    </div>
  );
};
